import type { UseHttp } from '~/api/interface'
export const fetchOssInfo: UseHttp = (params, option) => {
  return useHttp.get(`/api/oss/info`, undefined, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    ...option
  })
}


export const fetchOSSNewsContent: UseHttp = (params, option) => {
  return useHttp.get(`/ossApi/newsContent/${params?.newsId}.html`, undefined, { ...option })
}

export const fetchOSSInnerChainInfo: UseHttp = (params, option) => {
  return useHttp.get('/ossApi/InnerChainInfo/key.json', undefined, { ...option })
}
